export default {
  convert(result) {
    return result;
  }
};
